import {HttpClient} from '@angular/common/http';
import {Component, ViewChild, AfterViewInit, OnInit} from '@angular/core';
import {MatPaginator, MatSort, MatDialog} from '@angular/material';
import {merge, Observable, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import { DataUserService } from 'src/app/Services/data-user.service';
import { DataApiService } from 'src/app/Services/data-api.service';
import { User } from '../../../interfaces/users';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import { MAT_CHECKBOX_CLICK_ACTION } from '@angular/material';

/*excel*/
import *  as Excel from 'exceljs/dist/exceljs.min.js';
import * as FileSaver from 'file-saver';
import { AlertComponent } from '../alert/alert.component';

@Component({
  selector: 'app-dialog-liquidacion',
  templateUrl: './dialog-liquidacion.component.html',
  styleUrls: ['./dialog-liquidacion.component.scss'],
  providers:[
    {provide: MAT_DATE_LOCALE, useValue: 'es-ES'},
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
    {provide: MAT_CHECKBOX_CLICK_ACTION, useValue: 'check'}    
  ]
})

export class DialogLiquidacionComponent implements AfterViewInit {
  displayedColumns: string[] = ['id_pedido','razon_social','tipo_usuario_empresa','cod','retorno','estado','precio','precio_convenio','liquidado','dateTime_pedido'];
  exampleDatabase: ExampleHttpDatabase | null;
  data: GithubIssue[] = [];

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  idUser = this.DataUser.dataUser(this.dataApi.tokenUser(localStorage.getItem("token")));
  typeUser = localStorage.getItem("type");
  typeUserEmpresa = localStorage.getItem("tipoUsuarioEmpresa"); 

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
 

  constructor(
    private http: HttpClient,
    private DataUser:DataUserService,
    private dataApi:DataApiService,
    private dialog: MatDialog,) {}

  users:User[];

  public usersForm ={
    id:null,
    liquidado:null
  }

  public descargar ={
    idUser:null,
    desde:null,
    hasta:null
  }

  public liquidacion ={
    idUser :null,
    desde:null,
    hasta:null
  }
  
  campo_desde:boolean= false;
  campo_hasta:boolean = false;  

  campo_desde_liquidacion:boolean = false;
  campo_hasta_liquidacion:boolean = false;  
 

  mostrarAcciones:boolean = false;
 
  dateAfterFrom= null;
  dateAfterFromLiquidacion=null;

  observacion_reporte:boolean= false;
  observaciones_liquidacion:boolean=false;

  mensajeLiquidacion = "El proceso de liquidación se ha realizado con éxito";

  getListUser(){
    this.dataApi.usuariosPrincipales().subscribe( (data:User[])=>{
      this.users = data;       
    });    
  }
  onSubmit(){
    const id_user = this.usersForm.id;
    const liquidado = this.usersForm.liquidado;   
    (document.querySelector(".tablaLiquidacion") as HTMLElement).style.display="block";
    this.mostrarAcciones=true;
    this.descargar.idUser = id_user;
    this.descargar.desde=null;
    this.descargar.hasta=null;
    this.liquidacion.idUser =id_user;
    this.liquidacion.desde= null;
    this.liquidacion.hasta= null;
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.exampleDatabase!.getRepoIssues(
            id_user,liquidado,this.typeUser,this.typeUserEmpresa,this.sort.active, this.sort.direction, this.paginator.pageIndex);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;

          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  }

  activarReporte(event){
    if(event.checked== true){
      this.campo_desde=true;
      this.campo_hasta = true;      
    }else{
      this.campo_desde=false;
      this.campo_hasta = false;
      this.descargar.desde=null;
      this.descargar.hasta=null;
    }
  }
  activarLiquidacion(event){
    if(event.checked== true){
      this.campo_desde_liquidacion=true;
      this.campo_hasta_liquidacion = true;
    }else{
      this.campo_desde_liquidacion=false;
      this.campo_hasta_liquidacion = false;
      this.liquidacion.desde=null;
      this.liquidacion.hasta=null;
    }
  }
  minHastaDate(e){
    const date = new Date(e);
    this.dateAfterFrom = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    this.descargar.hasta=null;
    this.observacion_reporte=false;
  }
  minHastaDateLiquidacion(e){
    const date = new Date(e);
    this.dateAfterFromLiquidacion = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    this.liquidacion.hasta=null;
    this.observaciones_liquidacion=false;
  }
  ngAfterViewInit() {
    this.getListUser();
    this.exampleDatabase = new ExampleHttpDatabase(this.http,this.dataApi);

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.exampleDatabase!.getRepoIssues(
            this.idUser,2,this.typeUser,this.typeUserEmpresa,this.sort.active, this.sort.direction, this.paginator.pageIndex);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;

          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  }
 
  descargarReporte(){   
    this.dataApi.descargarReporte(this.descargar).subscribe((data)=>{
      if(data["total_count"]== 0){
        this.observacion_reporte=true;        
      }else{      
        this.observacion_reporte=false;
        const items = data["items"];
        const desde = data["desde"];
        const hasta = data["hasta"];
        const razon_social = data["razon_social"][0].razon_social;
        items.map((dato)=>{
          dato.retorno = (dato.retorno == 0) ? "NO" :"SI";
          dato.cod = (dato.cod == 0) ? "NO" :"SI";
          dato.tipoPago = (dato.tipoPago == 0) ? "Factura" :"Boleta";
          return dato;
       })
       this.exportToExcel(items,desde,hasta,razon_social);  
      }   
               
    });
  }
  exportToExcel(data,desde,hasta,razon_social){
    const rowInicioRegistro =8;
    var workbook = new Excel.Workbook();
    workbook.creator = "web";
    workbook.lastModifiedBy = "web";
    workbook.created = new Date();
    workbook.modified =  new Date();
    workbook.addWorksheet('SheetTest', { views: [{ activeCell: 'A1', showGridLines: true }] })
    var sheet = workbook.getWorksheet(1);

    sheet.mergeCells('B1:B3');
    

    sheet.mergeCells('C1:D1');
    sheet.getCell('C1').value="JOHNSON MILLER";
    sheet.getCell('C1').font ={
      name:'Arial',
      color: { argb: '00000000' },
      family: 2,
      size: 14,
      italic: false,
      bold:true
    }

    sheet.mergeCells('C2:D2');
    sheet.getCell('C2').value="Cal. German Schereiber 276 Int. 240, San Isidro, Lima";
    sheet.getCell('C2').font ={
      name:'Arial',
      color: { argb: '00000000' },
      family: 2,
      size: 10,
      italic: false,
      bold:true
    }

    sheet.mergeCells('C3:D3');
    sheet.getCell('C3').value="RUC.: 20603477015";
    sheet.getCell('C3').font ={
      name:'Arial',
      color: { argb: '00000000' },
      family: 2,
      size: 10,
      italic: false,
      bold:true
    }

    sheet.mergeCells('A5:G5');
    sheet.getCell('A5').value=`Liquidación de servicios ${razon_social}`;
    sheet.getCell('A5').font ={
      name:'Arial',
      color: { argb: '00000000' },
      family: 2,
      size: 14,
      italic: false,
      bold:true
    }
    sheet.getCell('A5').alignment = { vertical: 'middle', horizontal: 'center' };

    sheet.mergeCells('A6:G6');
    sheet.getCell('A6').value= `Del ${desde} hasta ${hasta} `;
    sheet.getCell('A6').font ={
      name:'Arial',
      color: { argb: '00000000' },
      family: 2,
      size: 10,
      italic: false,
      bold:true
    }
    sheet.getCell('A6').alignment = { vertical: 'middle', horizontal: 'center' };

   
    sheet.getRow(rowInicioRegistro).border ={
      top: {style:'thin'},
      left: {style:'thin'},
      bottom: {style:'thin'},
      right: {style:'thin'}
    }
    sheet.getRow(rowInicioRegistro).values = [
            'ID Pedido',
            'Email',
            'Lugar de recojo',
            'Fecha de recojo',
            'Hora de recojo',
            'Observaciones recojo',
            'Lugar de entrega',
            'Fecha de entrega',
            'Hora de entrega',
            'Observaciones entrega',
            'COD',
            'Retorno',
            'Precio',
            'Precio Convenio',
            'Tipo de Comprobante',
            'RUC Factura',
            'Razón Social Factura',
            'Descripción',
            'Día del pedido',
            'Hora del pedido'          
    ]; 
    sheet.getRow(rowInicioRegistro).height= 25;
    sheet.getRow(rowInicioRegistro).alignment= { vertical: 'middle', horizontal: 'center' };
    sheet.getRow(rowInicioRegistro).font ={
      name:'Arial',
      color: { argb: '00000000' },
      family: 2,
      size: 10,
      italic: false,
      bold:true
    }
    sheet.columns = [
      { key: 'id_pedido',width:10 },
      { key: 'email',width:30 },
      { key: 'lugarRecojo',width:50 },
      { key: 'fechaRecojo',width:20 },
      { key: 'horaRecojo',width:20 },
      { key: 'observaciones_recojo',width:40 },
      { key: 'lugarEntrega',width:50 },
      { key: 'fechaEntrega',width:20 },
      { key: 'horaEntrega',width:20 },
      { key: 'observaciones_entrega',width:40 },
      { key: 'cod',width:10 },
      { key: 'retorno',width:10 },  
      { key: 'precio',width:20 },   
      { key: 'precio_convenio',width:20 },
      { key: 'tipoPago',width:25 },
      { key: 'RUCFactura',width:20 },
      { key: 'RazonSocialFactura',width:50 },
      { key: 'descripcion',width:70 },
      { key: 'dia_pedido',width:20 },
      { key: 'hora_pedido',width:20 }
    ];       
    sheet.addRows(data);

    

    workbook.xlsx.writeBuffer().then(data => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' }); 
      FileSaver.saveAs(blob, `reporte-${razon_social}-${desde}-${hasta}.xlsx` );
    });
  }

  procesarLiquidacion(){
    this.dataApi.liquidar(this.liquidacion).subscribe((data)=>{
      if( data["total_count"]==0 ){
        this.observaciones_liquidacion=true;
      }else{
        this.observaciones_liquidacion=false;        
        this.dialog.closeAll();
        const dialogRef = this.dialog.open(AlertComponent,{
          width:"40%",
          data:{mensaje:this.mensajeLiquidacion},
          disableClose: false,
          autoFocus:true
        }); 

        dialogRef.afterClosed().subscribe(result => {      
          this.mensajeLiquidacion = result;
        });
      }     
    })
  }
}

export interface GithubApi {
  items: GithubIssue[];
  total_count: number;
}

export interface GithubIssue {
  id_pedido: number;
  razon_social:string;
  tipo_usuario_empresa:string;
  cod:number;
  retorno:number;
  estado:number;
  precio:any;
  precio_convenio:any;
  liquidado:number;
  dia_pedido:any;
  hora_pedido:any;
  
}

/** An example database that the data source uses to retrieve data for the table. */
export class ExampleHttpDatabase {
  constructor(
    private http: HttpClient,
    private dataApi:DataApiService
    ) {}

  
  getRepoIssues(idUser:number,liquidado:number,typeUser:string,typeUserEmpresa:string,sort: string, order: string, page: number): Observable<GithubApi> {
    const href = this.dataApi.url;
    const requestUrl =
    `${href}/mostrarPedidosLiquidacion/${page + 1}/15/${idUser}/${liquidado}`;    
    return this.http.get<GithubApi>(requestUrl);
  }
}
